import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation } from "@tanstack/react-query";
import { deleteData } from "../../utility/managerApi";

function ChatDelete({ messageId }) {
  const DeleteMessage = useMutation({
    mutationFn: () => deleteData("chats/delete/", messageId),
    onSuccess: () => {
      // Automatically refetches the "cart" query, ensuring the data is correct
      // queryClient.invalidateQueries("notifications");
    },
  });

  const handleDelete = (id) => {
    DeleteMessage.mutate(id);
  };
  return (
    <div>
      <DeleteIcon
        sx={{
          fontSize: { xs: 20, sm: 15, md: 30 },
        }}
        className="text-red-500 cursor-pointer"
        onClick={() => handleDelete(messageId)}
      />
    </div>
  );
}

export default ChatDelete;
